import { cn } from '../lib/utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('vai-animate-pulse vai-rounded-md vai-bg-muted', className)}
      {...props}
    />
  );
}

export { Skeleton };
